import { Injectable } from "@angular/core";
import { Actions } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import {
	CheckoutState,
	MobileActivate,
	PlanState,
	resetActivate,
	resetCheckoutState,
	resetPlan,
	setThankYou,
	ThanksYouState,
} from "../../_store";

@Injectable({
	providedIn: "root",
})
export class StoreHandlerService {
	constructor(
		private checkoutStore: Store<CheckoutState>,
		private activateStore: Store<MobileActivate>,
		private planStore: Store<PlanState>,
		private thankYouStore: Store<ThanksYouState>
	) {}

	prepareThankYou(salesId): void {
		this.thankYouStore.dispatch(setThankYou({ thankYou: { salesId } }));
		setTimeout(() => {
			this.checkoutStore.dispatch(resetCheckoutState());
		}, 200);
		// this.planStore.dispatch(resetPlan());
		this.activateStore.dispatch(resetActivate());
	}
}
